import React from 'react';
import { Percent, DollarSign } from 'lucide-react';
import FormInput from './FormInput';

const DiscountOptions = ({ 
  remiseType, 
  setRemiseType, 
  remiseValue, 
  handleRemiseChange, 
  montantTotal 
}) => {
  return (
    <div className="bg-gray-50 p-4 rounded-lg">
      <h3 className="text-lg font-medium text-gray-900 mb-3">Options de remise</h3>
      <div className="space-y-3">
        <div className="flex items-center space-x-3">
          <button
            type="button"
            onClick={() => setRemiseType('pourcentage')}
            className={`flex-1 flex items-center justify-center px-3 py-2 rounded-lg text-sm ${
              remiseType === 'pourcentage'
                ? 'bg-[#202654] text-white'
                : 'bg-gray-100 text-gray-600'
            }`}
          >
            <Percent className="h-4 w-4 mr-1" />
            Pourcentage
          </button>
          <button
            type="button"
            onClick={() => setRemiseType('montant')}
            className={`flex-1 flex items-center justify-center px-3 py-2 rounded-lg text-sm ${
              remiseType === 'montant'
                ? 'bg-[#202654] text-white'
                : 'bg-gray-100 text-gray-600'
            }`}
          >
            <DollarSign className="h-4 w-4 mr-1" />
            Montant
          </button>
        </div>
        <FormInput
          label={`Remise (${remiseType === 'pourcentage' ? '%' : 'FCFA'})`}
          name="remise_value"
          value={remiseValue}
          onChange={handleRemiseChange}
          type="number"
          min="0"
          max={remiseType === 'pourcentage' ? "100" : montantTotal}
        />
      </div>
    </div>
  );
};

export default DiscountOptions;
